import "./AdminPageLayout.css";

/**
 * Shared page shell for all admin pages.
 *
 * Props:
 *  - title        : string  — page heading
 *  - subtitle     : string  — short description shown below title
 *  - instruction  : string  — collapsible tip/guide shown as an info banner
 *  - actions      : node    — buttons rendered top-right (e.g. "+ Add" button)
 *  - children     : node    — page body content
 */
const AdminPageLayout = ({ title, subtitle, instruction, actions, children }) => (
  <div className="apl-page">
    <div className="apl-header">
      <div className="apl-header-left">
        <h1 className="apl-title">{title}</h1>
        {subtitle && <p className="apl-subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="apl-actions">{actions}</div>}
    </div>

    {instruction && (
      <div className="apl-instruction">
        <span className="apl-instruction-icon">💡</span>
        <span>{instruction}</span>
      </div>
    )}

    <div className="apl-body">{children}</div>
  </div>
);

export default AdminPageLayout;
